import Head from "next/head";
import React from "react";

import { useTranslation } from "../../core/translation.core";
import Gtag from "../common/gtag.comp";
import Footer from "./footer.comp";
import Header from "./header.comp";
import NoIndexMetaComp from "./noIndexMeta.comp";
import SearchBar from "../home/Search.comp";

interface LayoutProps {
  title: string;
  url?: string;
  children: React.ReactNode;
  type?: string;
  image?: string;
  imageWidth?: number;
  imageHeight?: number;
  description?: string;
}

export default function PageLayout({
  title,
  url,
  children,
  type = "website",
  image = "/images/blank-.png",
  imageWidth = 800,
  imageHeight = 600,
  description = "Shop our extensive collection of office equipment and electronics to elevate your workspace. Discover top-quality printers, scanners, computers, monitors, and more. Enhance productivity, streamline operations, and unlock new possibilities with our range of innovative solutions.",
}: LayoutProps) {
  const baseURL = process.env.NEXT_PUBLIC_URL_FRONT;
  const { t, msg } = useTranslation();

  return (
    <>
      <Head>
        <title>{`${title} - ${t(msg.site.name)}`}</title>
        {url && <meta property="og:url" content={baseURL + url} />}
        <meta property="og:type" content={type} />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <meta name="description" content={description} />
        <meta property="og:image" content={image} />
        <meta property="og:image:width" content={imageWidth.toString()} />
        <meta property="og:image:height" content={imageHeight.toString()} />
        <meta property="og:image:alt" content="Guru Guru HK Website" />
        <meta property="og:site_name" content="Guru Guru HK" />
      </Head>

      <NoIndexMetaComp />

      <Gtag />
      <Header SearchBar={<SearchBar />} />
      <section>{children}</section>
      <Footer />
    </>
  );
}
